module.exports = __webpack_public_path__ + "static/media/photo251.0c9721a7.jpg";